import { defineMessages } from "react-intl";

export default defineMessages({
  Unknown: {
    defaultMessage: "Unknown message",
    id: "unknown",
  },
});
